<template>
    <div class="file_pre" id="file_pre">
        <template  v-if="withLocationMark">
          <markPdf ref="pdf_view" :withLocationMark="withLocationMark"></markPdf>
        </template>
        <template v-else>
          <template v-if="fileType == 'VIDEO'">
            <video class="video" :src="url" controls></video>
          </template>
          <template v-else-if="isMarkdownFile">
              <markdown-content-preview :file-path="markdownFilePath"></markdown-content-preview>
          </template>
          <template v-else-if="isDwgFile">
              <cad-dwg-preview :url="url" :knowledge-item="knowledgeItem"></cad-dwg-preview>
          </template>
          <template v-else-if="fileType == 'HTML' || knowledgeItem && knowledgeItem.originUrl">
              <div class="preview_wechat" id="preview_wechat" style="text-align:left;" @click="getImg($event, fileText)" v-html="fileText"></div>
          </template>
          <template v-else>
              <iframe
                  class="preview_iframe"
                  :src="previewUrl"
                  style="border:none;"
                  :style="{height:iframeHeight}"
                  :key="key"
              ></iframe>
          </template>
        </template>
        <div class="loading_img" v-show="loading">
          <img src="../assets/images/loading.gif" alt="">
        </div>
        <img-view :url-list="imgList" @closeViewer="closeViewer" v-if="previewImage"></img-view>
    </div>
</template>
<script>

import { requestUrl } from "@/http/requestUrl";
import markPdf from "./markPdf.vue";
import waterMark from "@/utils/common";
import { mapGetters } from 'vuex'
import { v4 as uuidv4 } from "uuid";
import { setTimestamp } from '@/assets/js/common'
import axios from 'axios';
import MarkdownContentPreview from "./MarkdownContentPreview.vue";
import CadDwgPreview from "./CadDwgPreview.vue";
import ImgView from "./imgView";

export default {
    data () {
        return {
          fileText:"",
          loading: false,
          withLocationMark:null,
          iframeHeight:"100%",
          key:uuidv4(),
          specialPreviewUrl: '',   // ★ 解析服务返回的 html_result
          parseInfoCount: null,    // ★ 可保留统计信息
          imgList: [],
          previewImage: false,
        }
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        fileType: {
          type: String,
          default: '',
        },
        hiddenToolbar:{
          type: String,
          required: false,
        },
        knowledgeItem:{
          type:Object,
          default(){
            return {}
          }
        },
        textWatermarkStr:{
          type: String,
          default: '',
        }
    },
    mounted() {
      // let iframe = document.getElementsByClassName('preview_iframe')[0]
      // if(iframe) {
      //   // this.loading = true
      //   console.log('1111111');
      //   iframe.onload = () => {
      //     this.loading = false
      //   }
      // }
      // if(this.fileType == 'IMAGE') {
      //   document.getElementById('file_pre').style.height = '600px'
      // }
      this.loadIframe();
      window.addEventListener('message',this.handleIframeMessage,false)
      
      // 处理需要HTML预览的文件类型（HTML、URL、Markdown）
      if (this.shouldProcessHtmlPreview()) {
        console.log("检测到需要HTML预览的文件类型，开始处理图片签名");
        this.processHtmlPreview();
      }
    },
    components:{
      markPdf,
      MarkdownContentPreview,
      CadDwgPreview,
      ImgView
    },
    computed: {
        ...mapGetters('knowledge', {
          textWatermarkStr: 'getTextWatermarkStr'
        }),
        previewUrl () {
            let url = process.env.VUE_APP_NODE_ENV === 'production' ? 'https://kkfileview.askbot.cn/onlinePreview' :'https://test.open.askbot.cn/kkfileview/onlinePreview'
            url += '?url=' + this.url;
            if (this.fileType == 'PPT') {
              url += '&officePreviewType=pdf'
            }
            if (this.textWatermarkStr){
              url += '&textWatermarkValue=' + this.textWatermarkStr
            }
            // url += '&timestamp=' + new Date().getTime();
            url = setTimestamp(url)
            return url
        },
        isMarkdownFile() {
          return (
            this.fileType === 'OTHER' &&
            this.knowledgeItem &&
            (this.knowledgeItem.fileSuffix === 'md' ||
             (this.knowledgeItem.carrier && this.knowledgeItem.carrier.type === 'md'))
          )
        },
        isDwgFile() {
          const suffixRaw =
            (this.knowledgeItem && this.knowledgeItem.fileSuffix) ||
            (this.knowledgeItem && this.knowledgeItem.carrier && this.knowledgeItem.carrier.type) ||
            ''
          const suffix = String(suffixRaw).toLowerCase().replace(/^\./, '')
          if (suffix === 'dwg') {
            return true
          }
          const rawUrl = typeof this.url === 'string' ? this.url : ''
          const path = rawUrl.split('?')[0].split('#')[0]
          return path.toLowerCase().endsWith('.dwg')
        },
        markdownFilePath() {
          if (this.knowledgeItem) {
            return this.knowledgeItem.ossPath ||
              this.knowledgeItem.oss_path ||
              (this.knowledgeItem.carrier && this.knowledgeItem.carrier.cloudLocation) ||
              this.url
          }
          return this.url
        }
    },
    methods: {
      // 判断是否需要HTML预览处理
      shouldProcessHtmlPreview() {
        if (this.isMarkdownFile) {
          return false
        }
        return this.fileType === 'HTML' || 
               (this.knowledgeItem && this.knowledgeItem.originUrl);
      },

      // 处理HTML预览，包括图片签名
      async processHtmlPreview() {
        if (this.fileType === 'HTML') {
          // HTML类型文件，直接获取预览内容
          this.getPreviewContent(this.url);
        } else if (this.knowledgeItem && this.knowledgeItem.originUrl) {
          // URL类型文件，获取解析后的HTML内容
          this.getParseInfoCount();
        }
      },

      getPreviewContent(fileInOssPath){
        this.fileText = "";
        let url = requestUrl.preview.previewContent;
        this.$http.post(url,{
          fileInOssPath: fileInOssPath,
        }).then(res => {
          if (res.data.data){
            // 对HTML内容进行图片签名处理
            this.processImagesInHtml(res.data.data).then(processedHtml => {
              this.fileText = processedHtml;
              this.loading = false;
            }).catch(err => {
              console.error("图片签名处理失败:", err);
              this.fileText = res.data.data;
              this.loading = false;
            });
          }
        })
      },
      loadIframe () {
        if (this.fileType == 'VIDEO' || this.fileType == 'WECHAT') {
          this.loading = false
        } else if (this.isMarkdownFile) {
          // Markdown文件不需要iframe加载逻辑
          this.loading = false;
        } else if (this.isDwgFile) {
          // DWG 使用 cad-simple-viewer，不依赖 iframe onload
          this.loading = false;
        } else {
          let iframes = document.getElementsByClassName('preview_iframe');
          for (let index = 0; index < iframes.length; index++) {
            iframes[index].onload = () => {
                this.loading = false;
                iframes[index].style.backgroundImage = "none";
            }
          }
          if (this.fileType === 'HTML'){
            setTimeout(() => {
              waterMark.newInitWaterMark('preview_wechat',this.textWatermarkStr)
            },500)
          }
        }
      },
      getInnermostIframe() {
        let iframes = document.querySelectorAll('iframe');
        for (let i = 0; i < iframes.length; i++) {
          let innerIframes = iframes[i].querySelectorAll('iframe');
          if (innerIframes.length > 0) {
            return innerIframes[0];
          }
        }
        return null;
      },
      openMark() {
        this.$refs.pdf_view.openMark()
      },
      handleIframeMessage(res){
        if (res.data.type == 'getViewerHeight'){
          let iframeHeight = this.iframeHeight.replace('px','')
          if (res.data.data && iframeHeight != (res.data.data + 50)){
            this.iframeHeight = res.data.data + 50 + 'px'
          }
        }
      },
      // 取 html_result 并写入 specialPreviewUrl
      getParseInfoCount() {
        const url = `/knowledge-api/correction/knowledge-parse-info/${this.$route.query.knowledgeId}`;
        this.$http.get(url).then(res => {
          console.log("res:", res);
          if (res.data.code === "0" && res.data.data) {
            // 获取 html_result 路径
            const htmlRes = res.data.data?.extractChunkInfo?.docChunkData?.html_result;
            if (htmlRes) {
              // 请求该 URL 获取 HTML 内容
              axios.get(htmlRes) // 通过 axios 请求获取内容
                .then(response => {
                  // 处理HTML中的图片，添加签名
                  this.processImagesInHtml(response.data).then(processedHtml => {
                    this.fileText = processedHtml;
                    this.loading = false;
                  }).catch(err => {
                    console.error("图片签名处理失败:", err);
                    this.fileText = response.data;
                    this.loading = false;
                  });
                })
                .catch(error => {
                  console.error("获取 HTML 内容失败:", error);
                  this.loading = false; // 即使请求失败，也结束加载
                });
              
              // 设置为 iframe 预览地址
              this.specialPreviewUrl = htmlRes;
            }
          }
        });
      },

      // 处理 HTML 中的图片链接，为私有 OSS 图片添加签名
      async processImagesInHtml(htmlContent) {
        if (!htmlContent || typeof htmlContent !== 'string') {
          // console.warn("HTML内容为空或格式不正确");
          return htmlContent;
        }

        // 匹配图片标签，支持单引号和双引号
        const imgRegex = /<img[^>]*src\s*=\s*["']([^"']+)["'][^>]*>/gi;
        let match;
        const imageUrls = [];

        console.log("开始匹配图片链接...");
        
        // 收集所有图片URL
        while ((match = imgRegex.exec(htmlContent)) !== null) {
          const imgUrl = match[1];
          if (imgUrl && imgUrl.includes('oss-cn-zhangjiakou.aliyuncs.com') && !imgUrl.includes('Expires=')) {
            imageUrls.push(imgUrl);
          } else {
            console.log("跳过图片 URL:", imgUrl, "原因:", !imgUrl ? "空URL" : !imgUrl.includes('oss-cn-zhangjiakou.aliyuncs.com') ? "非OSS" : "已有签名");
          }
        }
        
        console.log("需要处理的图片数量:", imageUrls.length);
        
        if (imageUrls.length === 0) {
          console.log("没有需要处理的图片，直接返回原内容");
          return htmlContent;
        }

        // 为每个图片获取签名URL
        const signedUrls = {};
        for (const imgUrl of imageUrls) {
          try {
            const previewApi = requestUrl.preview.previewUrl + '?isVersionManage=1&needEncrypt=false';
            const resp = await this.$http.post(previewApi, { fileInOssPath: imgUrl });
            if (resp.data && resp.data.code === "0") {
              signedUrls[imgUrl] = resp.data.data;
              // console.log("图片签名成功:", imgUrl, "->", resp.data.data);
            } else {
              console.error("签名接口返回错误:", resp.data);
            }
          } catch (err) {
            console.error("图片签名失败:", imgUrl, err);
            console.error("错误详情:", err.response ? err.response.data : err.message);
          }
        }
        
        // 替换HTML中的图片URL
        let processedHtml = htmlContent;
        Object.keys(signedUrls).forEach(originalUrl => {
          const signedUrl = signedUrls[originalUrl];
          // 使用更安全的替换逻辑
          const escapedUrl = originalUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          processedHtml = processedHtml.replace(new RegExp(escapedUrl, 'g'), signedUrl);
          // console.log("替换图片链接:", originalUrl, "->", signedUrl);
        });
        
        console.log("处理完成，替换了", Object.keys(signedUrls).length, "个图片链接");
        return processedHtml;
      },
      getImg(event, htmlContent) {
        if (event.target.localName === 'img') {
          this.imgList = []
          let richtext = htmlContent
          this.imgList = [];
          richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
            this.imgList.push(capture);
          });
          /*当前点击的图片作为第一个图片*/
          let index = this.imgList.indexOf(event.target.currentSrc);
          if (index !== -1) {
            this.imgList.splice(index, 1);
          }
          this.imgList.unshift(event.target.currentSrc);
          this.previewImage = true;
        }
      },
      closeViewer() {
        this.previewImage = false;
      },
    },
    watch:{
      withLocationMark(value) {
        if(value) {
          this.loading = false
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleIframeMessage);
    }
}
</script>
<style lang="less" scoped>
.file_pre {
    width: 100%;
    //min-height: 400px;
    //height: calc(100% - 40px);
    min-height: 400px;
    position: relative;
    visibility: inherit !important;
    .preview_iframe {
        width: 100%;
        //height: 100%;
        background-image: url('../assets/images/loading.gif');
        background-position: center;
        background-size: 50px;
        background-repeat: no-repeat;
    }
    .video {
        width: 80%;
        height: 50%;
    }
    .preview_wechat {
        width: 100%;
        //height: calc(100% - 32px);
        //height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: auto;
        //overflow-x: scroll;
        padding: 16px;
      background-color: #ffffff;
      border-radius: 5px;
    }
  /deep/img{
    width: 100%;
  }
  /deep/.ne-table{
    width: 100% !important;
  }
}
.loading_img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #FFF;
  img {
    width: 50px;
    height: 50px;
  }
}
</style>
